import api from '../instance/axios_instance.ts';
import { CreditInterface } from '../interface/creditInterface.ts';
const CreditApi = async (customer_id: number): Promise<CreditInterface> => {
    try {
        const response = await api.get<CreditInterface>('/credit',{
            params: { customer_id }
        });

        return response.data;
    } catch (error) {
        const mensajeError = error.response?.data?.message;
        throw new Error(mensajeError || 'Error credito');
    }
}

export default CreditApi;